module.exports = __webpack_public_path__ + "img/customer-retention-calculator.e61c4282.png";